import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";

const Tos: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="container mx-auto px-4 py-8 text-white">
      <h1 className="text-4xl font-bold text-center mb-8">TERMS OF SERVICE</h1>
      <div className="space-y-6 text-lg leading-relaxed">
        <p className="text-center">Last updated: 08/25/2025</p>

        <p className="font-bold underline">
          1. <span className="inline-block text-[7pt]"> </span>
          Introduction
        </p>
        <p>
          Welcome to <b>PearEasy Aps</b> (“<b>Company</b>”, “<b>we</b>”, “
          <b>our</b>”, “<b>us</b>”)! As you have just clicked our Terms of
          Service, please pause, grab a cup of coffee and carefully read the
          following pages. It will take you approximately 20 minutes.
        </p>
        <p>
          These Terms of Service (“<b>Terms</b>”, “<b>Terms of Service</b>”)
          govern your use of our web pages located at easysbc.io and our mobile
          application EasySBC (together or individually “<b>Service</b>”)
          operated by PearEasy Aps.
        </p>
        <p>
          Our Privacy Policy also governs your use of our Service and explains
          how we collect, safeguard and disclose information that results from
          your use of our web pages. Please read it here{" "}
          <NavLink to="/legal/privacy" className="text-blue-400 underline">
            privacy policy
          </NavLink>
          .
        </p>
        <p>
          Your agreement with us includes these Terms and our Privacy Policy (“
          <b>Agreements</b>”). You acknowledge that you have read and understood
          Agreements by accessing or using any part of our Services, and agree
          to be bound by them.
        </p>
        <p>
          If you do not agree with (or cannot comply with) Agreements, then you
          may not use the Service, but please let us know by emailing at
          peareasy.sbc@gmail.com so we can try to find a solution. These Terms
          apply to all visitors, users and others who wish to access or use
          Service.
        </p>
        <p>Thank you for being responsible.</p>

        <p className="font-bold underline">2. Purchases</p>
        <p>
          If you wish to purchase any product or service made available through
          Service (“<b>Purchase</b>”), you may be asked to supply certain
          information relevant to your Purchase including, without limitation,
          your credit card number, the expiration date of your credit card, your
          billing address, and your shipping information.
        </p>
        <p>
          You represent and warrant that: (i) you have the legal right to use
          any credit card(s) or other payment method(s) in connection with any
          Purchase; and that (ii) the information you supply to us is true,
          correct and complete.
        </p>
        <p>
          We may employ the use of third party services for the purpose of
          facilitating payment and the completion of Purchases. By submitting
          your information, you grant us the right to provide the information to
          these third parties subject to our Privacy Policy.
        </p>
        <p>
          We reserve the right to refuse or cancel your order at any time for
          reasons including but not limited to: product or service availability,
          errors in the description or price of the product or service, error in
          your order or other reasons.
        </p>
        <p>
          We reserve the right to refuse or cancel your order if fraud or an
          unauthorized or illegal transaction is suspected.
        </p>

        <p className="font-bold underline">
          3. Contests, Sweepstakes and Promotions
        </p>
        <p>
          Any contests, sweepstakes or other promotions (collectively, “
          <b>Promotions</b>”) made available through Service may be governed by
          rules that are separate from these Terms of Service. If you
          participate in any Promotions, please review the applicable rules as
          well as our Privacy Policy. If the rules for a Promotion conflict with
          these Terms of Service, Promotion rules will apply.
        </p>

        <p className="font-bold underline">4. Subscriptions</p>
        <p>
          Some parts of Service are billed on a subscription basis (“
          <b>Subscription(s)</b>”). You will be billed in advance on a recurring
          and periodic basis (“<b>Billing Cycle</b>”). Billing cycles are set on
          a monthly basis.
        </p>
        <p>
          At the end of each Billing Cycle, your Subscription will automatically
          renew under the exact same conditions unless you cancel it or PearEasy
          Aps cancels it. You may cancel your Subscription renewal either
          through your online account management page or by contacting PearEasy
          Aps customer support team.
        </p>
        <p>
          A valid payment method, including credit card, is required to process
          the payment for your subscription. You shall provide PearEasy Aps with
          accurate and complete billing information including full name,
          address, state, zip code, telephone number, and a valid payment method
          information. By submitting such payment information, you automatically
          authorize PearEasy Aps to charge all Subscription fees incurred
          through your account to any such payment instruments.
        </p>
        <p>
          Should automatic billing fail to occur for any reason, PearEasy Aps
          will issue an electronic invoice indicating that you must proceed
          manually, within a certain deadline date, with the full payment
          corresponding to the billing period as indicated on the invoice.
        </p>
        <p>
          We reserve the right to modify Subscription fees for the Subscriptions
          at any time. Any Subscription fee change will become effective at the
          end of the then-current Billing Cycle. PearEasy Aps will provide you
          with a reasonable prior notice of any change in Subscription fees to
          give you an opportunity to terminate your Subscription before such
          change becomes effective. Your continued use of Service after
          Subscription fee change comes into effect constitutes your agreement
          to pay the modified Subscription fee amount.
        </p>

        <p className="font-bold underline">5. Fee Changes</p>
        <p>
          PearEasy Aps, in its sole discretion and at any time, may modify
          Subscription fees for the Subscriptions. Any Subscription fee change
          will become effective at the end of the then-current Billing Cycle.
        </p>
        <p>
          PearEasy Aps will provide you with a reasonable prior notice of any
          change in Subscription fees to give you an opportunity to terminate
          your Subscription before such change becomes effective.
        </p>
        <p>
          Your continued use of Service after Subscription fee change comes into
          effect constitutes your agreement to pay the modified Subscription fee
          amount.
        </p>

        <p className="font-bold underline">6. Refunds</p>
        <p>
          Except when required by law, paid Subscription fees are
          non-refundable.
        </p>

        <p className="font-bold underline">7. Content</p>
        <p>
          Content found on or through this Service are the property of PearEasy
          Aps or used with permission. You may not distribute, modify, transmit,
          reuse, download, repost, copy, or use said Content, whether in whole
          or in part, for commercial purposes or for personal gain, without
          express advance written permission from us.
        </p>
        <p>
          We reserve the right to refuse service, terminate accounts, remove or
          edit content, or cancel orders in our sole discretion.
        </p>

        <p className="font-bold underline">8. Prohibited Uses</p>
        <p>
          You may use Service only for lawful purposes and in accordance with
          Terms. You agree not to use Service:
        </p>
        <p className="ml-8 text-justify">
          (a) In any way that violates any applicable national or international
          law or regulation.
        </p>
        <p className="ml-8 text-justify">
          (b) For the purpose of exploiting, harming, or attempting to exploit
          or harm minors in any way by exposing them to inappropriate content or
          otherwise.
        </p>
        <p className="ml-8 text-justify">
          (c) To transmit, or procure the sending of, any advertising or
          promotional material, including any “junk mail”, “chain letter,”
          “spam,” or any other similar solicitation.
        </p>
        <p className="ml-8 text-justify">
          (d) To impersonate or attempt to impersonate Company, a Company
          employee, another user, or any other person or entity.
        </p>
        <p className="ml-8 text-justify">
          (e) In any way that infringes upon the rights of others, or in any way
          is illegal, threatening, fraudulent, or harmful, or in connection with
          any unlawful, illegal, fraudulent, or harmful purpose or activity.
        </p>
        <p className="ml-8 text-justify">
          (f) To engage in any other conduct that restricts or inhibits anyone’s
          use or enjoyment of Service, or which, as determined by us, may harm
          or offend Company or users of Service or expose them to liability.
        </p>

        <p className="font-bold underline">9. Analytics</p>
        <p>
          We may use third-party Service Providers to monitor and analyze the
          use of our Service.
        </p>
        <p className="font-medium font-arial">Google Analytics</p>
        <p>
          Google Analytics is a web analytics service offered by Google that
          tracks and reports website traffic. Google uses the data collected to
          track and monitor the use of our Service. This data is shared with
          other Google services. Google may use the collected data to
          contextualise and personalise the ads of its own advertising network.
        </p>
        <p>
          For more information on the privacy practices of Google, please visit
          the Google Privacy Terms web page:{" "}
          <a
            href="https://policies.google.com/privacy?hl=en"
            className="text-blue-400 underline"
          >
            https://policies.google.com/privacy?hl=en
          </a>
        </p>

        <p className="font-bold underline">10. No Use By Minors</p>
        <p>
          Service is intended only for access and use by individuals at least
          eighteen (18) years old. By accessing or using any of Company, you
          warrant and represent that you are at least eighteen (18) years of age
          and with the full authority, right, and capacity to enter into this
          agreement and abide by all of the terms and conditions of Terms. If
          you are not at least eighteen (18) years old, you are prohibited from
          both the access and usage of Service.
        </p>

        <p className="font-bold underline">11. Accounts</p>
        <p>
          When you create an account with us, you guarantee that you are above
          the age of 18, and that the information you provide us is accurate,
          complete, and current at all times. Inaccurate, incomplete, or
          obsolete information may result in the immediate termination of your
          account on Service.
        </p>
        <p>
          You are responsible for maintaining the confidentiality of your
          account and password, including but not limited to the restriction of
          access to your computer and/or account. You agree to accept
          responsibility for any and all activities or actions that occur under
          your account and/or password, whether your password is with our
          Service or a third-party service. You must notify us immediately upon
          becoming aware of any breach of security or unauthorized use of your
          account.
        </p>
        <p>
          You may not use as a username the name of another person or entity or
          that is not lawfully available for use, a name or trademark that is
          subject to any rights of another person or entity other than you,
          without appropriate authorization. You may not use as a username any
          name that is offensive, vulgar or obscene.
        </p>
        <p>
          We reserve the right to refuse service, terminate accounts, remove or
          edit content, or cancel orders in our sole discretion.
        </p>

        <p className="font-bold underline">12. Intellectual Property</p>
        <p>
          This Agreement does not transfer from Company to you any Company or
          third party intellectual property, and all right, title, and interest
          in and to such property will remain (as between the parties) solely
          with Company. Company, Service, the Company logo and the Service logo,
          and all other trademarks, service marks, graphics and logos used in
          connection with easysbc.io or our Services, are trademarks or
          registered trademarks of Company or Company’s licensors. Other
          trademarks, service marks, graphics and logos used in connection with
          our Services may be the trademarks of other third parties. Your use of
          our Services grants you no right or license to reproduce or otherwise
          use any Company or third-party trademarks.
        </p>

        <p className="font-bold underline">13. Copyright Policy</p>
        <p>
          We respect the intellectual property rights of others. It is our
          policy to respond to any claim that Content posted on Service
          infringes on the copyright or other intellectual property rights (“
          <b>Infringement</b>”) of any person or entity.
        </p>
        <p>
          If you are a copyright owner, or authorized on behalf of one, and you
          believe that the copyrighted work has been copied in a way that
          constitutes copyright infringement, please submit your claim via email
          to peareasy.sbc@gmail.com, with the subject line: “Copyright
          Infringement” and include in your claim a detailed description of the
          alleged Infringement as detailed below, under “DMCA Notice and
          Procedure for Copyright Infringement Claims”.
        </p>
        <p>
          You may be held accountable for damages (including costs and
          attorneys' fees) for misrepresentation or bad-faith claims on the
          infringement of any Content found on and/or through Service on your
          copyright.
        </p>

        <p className="font-bold underline">
          14. DMCA Notice and Procedure for Copyright Infringement Claims
        </p>
        <p>
          You may submit a notification pursuant to the Digital Millennium
          Copyright Act (DMCA) by providing our Copyright Agent with the
          following information in writing (see 17 U.S.C 512(c)(3) for further
          detail):
        </p>
        <p className="ml-8 text-justify text-[10pt] font-arial">
          (a) an electronic or physical signature of the person authorized to
          act on behalf of the owner of the copyright's interest;
        </p>
        <p className="ml-8 text-justify text-[10pt] font-arial">
          (b) a description of the copyrighted work that you claim has been
          infringed, including the URL (i.e., web page address) of the location
          where the copyrighted work exists or a copy of the copyrighted work;
        </p>
        <p className="ml-8 text-justify text-[10pt] font-arial">
          (c) identification of the URL or other specific location on Service
          where the material that you claim is infringing is located;
        </p>
        <p className="ml-8 text-justify text-[10pt] font-arial">
          (d) your address, telephone number, and email address;
        </p>
        <p className="ml-8 text-justify text-[10pt] font-arial">
          (e) a statement by you that you have a good faith belief that the
          disputed use is not authorized by the copyright owner, its agent, or
          the law;
        </p>
        <p className="ml-8 text-justify text-[10pt] font-arial">
          (f) a statement by you, made under penalty of perjury, that the above
          information in your notice is accurate and that you are the copyright
          owner or authorized to act on the copyright owner's behalf.
        </p>
        <p>
          You can contact our Copyright Agent via email at
          peareasy.sbc@gmail.com.
        </p>

        <p className="font-bold underline">15. Error Reporting and Feedback</p>
        <p>
          You may provide us either directly at peareasy.sbc@gmail.com or via
          third party sites and tools with information and feedback concerning
          errors, suggestions for improvements, ideas, problems, complaints, and
          other matters related to our Service (“<b>Feedback</b>”). You
          acknowledge and agree that: (i) you shall not retain, acquire or
          assert any intellectual property right or other right, title or
          interest in or to the Feedback; (ii) Company may have development
          ideas similar to the Feedback; (iii) Feedback does not contain
          confidential information or proprietary information from you or any
          third party; and (iv) Company is not under any obligation of
          confidentiality with respect to the Feedback. In the event the
          transfer of the ownership to the Feedback is not possible due to
          applicable mandatory laws, you grant Company and its affiliates an
          exclusive, transferable, irrevocable, free-of-charge, sub-licensable,
          unlimited and perpetual right to use (including copy, modify, create
          derivative works, publish, distribute and commercialize) Feedback in
          any manner and for any purpose.
        </p>
        <p>
          The third party sites and tools mentioned above include the following:
        </p>
        <p className="font-medium font-arial">Bugsnag</p>
        <p>
          Bugsnag is a platform for monitoring and logging stability of
          applications provided by Bugsnag Inc. Please read their Privacy Policy
          here:{" "}
          <a
            href="https://docs.bugsnag.com/legal/privacy-policy/"
            className="text-blue-400 underline"
          >
            https://docs.bugsnag.com/legal/privacy-policy/
          </a>
        </p>

        <p className="font-bold underline">16. Links To Other Web Sites</p>
        <p>
          Our Service may contain links to third party web sites or services
          that are not owned or controlled by PearEasy Aps.
        </p>
        <p>
          PearEasy Aps has no control over, and assumes no responsibility for
          the content, privacy policies, or practices of any third party web
          sites or services. We do not warrant the offerings of any of these
          entities/individuals or their websites.
        </p>

        <p className="font-bold underline">17. Disclaimer Of Warranty</p>
        <p>
          THESE SERVICES ARE PROVIDED BY COMPANY ON AN “AS IS” AND “AS
          AVAILABLE” BASIS. COMPANY MAKES NO REPRESENTATIONS OR WARRANTIES OF
          ANY KIND, EXPRESS OR IMPLIED, AS TO THE OPERATION OF THEIR SERVICES,
          OR THE INFORMATION, CONTENT OR MATERIALS INCLUDED THEREIN. YOU
          EXPRESSLY AGREE THAT YOUR USE OF THESE SERVICES, THEIR CONTENT, AND
          ANY SERVICES OR ITEMS OBTAINED FROM US IS AT YOUR SOLE RISK.
        </p>
        <p>
          NEITHER COMPANY NOR ANY PERSON ASSOCIATED WITH COMPANY MAKES ANY
          WARRANTY OR REPRESENTATION WITH RESPECT TO THE COMPLETENESS, SECURITY,
          RELIABILITY, QUALITY, ACCURACY, OR AVAILABILITY OF THE SERVICES.
          WITHOUT LIMITING THE FOREGOING, NEITHER COMPANY NOR ANYONE ASSOCIATED
          WITH COMPANY REPRESENTS OR WARRANTS THAT THE SERVICES, THEIR CONTENT,
          OR ANY SERVICES OR ITEMS OBTAINED THROUGH THE SERVICES WILL BE
          ACCURATE, RELIABLE, ERROR-FREE, OR UNINTERRUPTED, THAT DEFECTS WILL BE
          CORRECTED, THAT THE SERVICES OR THE SERVER THAT MAKES IT AVAILABLE ARE
          FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS OR THAT THE SERVICES OR
          ANY SERVICES OR ITEMS OBTAINED THROUGH THE SERVICES WILL OTHERWISE
          MEET YOUR NEEDS OR EXPECTATIONS.
        </p>
        <p>
          THE FOREGOING DOES NOT AFFECT ANY WARRANTIES WHICH CANNOT BE EXCLUDED
          OR LIMITED UNDER APPLICABLE LAW.
        </p>

        <p className="font-bold underline">18. Limitation Of Liability</p>
        <p>
          EXCEPT AS PROHIBITED BY LAW, YOU WILL HOLD US AND OUR OFFICERS,
          DIRECTORS, EMPLOYEES, AND AGENTS HARMLESS FOR ANY INDIRECT, PUNITIVE,
          SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGE, HOWEVER IT ARISES
          (INCLUDING ATTORNEYS' FEES AND ALL RELATED COSTS AND EXPENSES OF
          LITIGATION AND ARBITRATION, OR AT TRIAL OR ON APPEAL, IF ANY, WHETHER
          OR NOT LITIGATION OR ARBITRATION IS INSTITUTED), WHETHER IN AN ACTION
          OF CONTRACT, NEGLIGENCE, OR OTHER TORTIOUS ACTION, OR ARISING OUT OF
          OR IN CONNECTION WITH THIS AGREEMENT, INCLUDING WITHOUT LIMITATION ANY
          CLAIM FOR PERSONAL INJURY OR PROPERTY DAMAGE, ARISING FROM THIS
          AGREEMENT AND ANY VIOLATION BY YOU OF ANY FEDERAL, STATE, OR LOCAL
          LAWS, STATUTES, RULES, OR REGULATIONS, EVEN IF COMPANY HAS BEEN
          PREVIOUSLY ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
        </p>
        <p>
          If there is liability found on the part of Company, it will be limited
          to the amount paid for the Products and/or Services, and under no
          circumstances will there be consequential or punitive damages. Some
          states do not allow the exclusion or limitation of punitive,
          incidental or consequential damages, so the prior limitation or
          exclusion may not apply to you.
        </p>

        <p className="font-bold underline">19. Indemnification</p>
        <p>
          You agree to indemnify and hold harmless Company, its contractors, and
          its licensors, and their respective directors, officers, employees,
          and agents from and against any and all claims and expenses, including
          attorneys’ fees, arising out of your use of our Services, including
          but not limited to your violation of this Agreement.
        </p>

        <p className="font-bold underline">20. Termination</p>
        <p>
          We may terminate or suspend your account and bar access to Service
          immediately, without prior notice or liability, under our sole
          discretion, for any reason whatsoever and without limitation,
          including but not limited to a breach of Terms.
        </p>
        <p>
          If you wish to terminate your account, you may simply discontinue
          using Service.
        </p>
        <p>
          All provisions of Terms which by their nature should survive
          termination shall survive termination, including, without limitation,
          ownership provisions, warranty disclaimers, indemnity and limitations
          of liability.
        </p>

        <p className="font-bold underline">21. Governing Law</p>
        <p>
          These Terms shall be governed and construed in accordance with the
          laws of Denmark without regard to its conflict of law provisions.
        </p>
        <p>
          Our failure to enforce any right or provision of these Terms will not
          be considered a waiver of those rights. If any provision of these
          Terms is held to be invalid or unenforceable by a court, the remaining
          provisions of these Terms will remain in effect. These Terms
          constitute the entire agreement between us regarding our Service and
          supersede and replace any prior agreements we might have had between
          us regarding Service.
        </p>

        <p className="font-bold underline">22. Changes To Service</p>
        <p>
          We reserve the right to withdraw or amend our Service, and any service
          or material we provide via Service, in our sole discretion without
          notice. We will not be liable if for any reason all or any part of
          Service is unavailable at any time or for any period. From time to
          time, we may restrict access to some parts of Service, or the entire
          Service, to users, including registered users.
        </p>

        <p className="font-bold underline">23. Amendments To Terms</p>
        <p>
          We may amend Terms at any time by posting the amended terms on this
          site. It is your responsibility to review these Terms periodically.
        </p>
        <p>
          Your continued use of the Platform following the posting of revised
          Terms means that you accept and agree to the changes. You are expected
          to check this page frequently so you are aware of any changes, as they
          are binding on you.
        </p>
        <p>
          By continuing to access or use our Service after any revisions become
          effective, you agree to be bound by the revised terms. If you do not
          agree to the new terms, you are no longer authorized to use Service.
        </p>

        <p className="font-bold underline">24. Waiver And Severability</p>
        <p>
          No waiver by Company of any term or condition set forth in Terms shall
          be deemed a further or continuing waiver of such term or condition or
          a waiver of any other term or condition, and any failure of Company to
          assert a right or provision under Terms shall not constitute a waiver
          of such right or provision.
        </p>

        <p className="font-bold underline">
          25. No Web Scraping, Crawling or Data Mining
        </p>
        <p>
          All forms of data mining, web scraping, or similar activities
          targeting our website and the services provided therein are strictly
          prohibited.
        </p>

        <p className="font-bold underline">26. Acknowledgement</p>
        <p>
          BY USING SERVICE OR OTHER SERVICES PROVIDED BY US, YOU ACKNOWLEDGE
          THAT YOU HAVE READ THESE TERMS OF SERVICE AND AGREE TO BE BOUND BY
          THEM.
        </p>

        <p className="font-bold underline">27. Contact Us</p>
        <p>
          Please send your feedback, comments, requests for technical support by
          visiting this page on our website:{" "}
          <a
            href="https://easysbc.io/contact"
            className="text-blue-400 underline"
          >
            easysbc.io/contact
          </a>
          .
        </p>
      </div>
    </main>
  );
};

export default Tos;
